import {Route, Routes, useNavigate} from 'react-router-dom'
import HomePage from './pages/HomePage'
import AppMenu from './components/layout/AppMenu'
import AppHeader from './components/layout/AppHeader'
import WelcomeCurtain from './components/layout/WelcomeCurtain'
import LoginPage from './pages/LoginPage'
import OtherPage from './pages/OtherPage'
import PasswordRecoveryPage from './pages/PasswordRecoveryPage'
import RegistrationPage from './pages/RegistrationPage'
import VOPPage from './pages/VOPPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import {$app, ReactComponent} from './app'
import {authenticate, removeApiAuthToken, setApiAuthToken, whereIsTheStateIn} from './helpers/global'
import FoodMenuPage from './pages/FoodMenuPage'
import RewardsPage from './pages/RewardsPage'
import {sleep} from './helpers/utils'
import ReservationPage from './pages/ReservationPage'
import AccountUpdatePage from "./pages/AccountUpdatePage"
import AccountChangePasswordPage from "./pages/AccountChangePasswordPage"

export class Root extends ReactComponent {
  isAuthorizedPromise= null

  state = {
    initialLoading: true,
    isAuthorized: false,
    touch: {
      customer_id: null
    }
  }

  get $auth() {
    return {
      isAuthorizedState: this.state.isAuthorized,
      isAuthorized: (() => {
        if(this.isAuthorizedPromise === null)
          this.isAuthorizedPromise = new Promise((resolve) => {
            whereIsTheStateIn().then(r => resolve(r.isAuthorized))
          })

        return this.isAuthorizedPromise
      })(),
      touch: async (response = null) => {
        try {
          const res = await $app.$api({
            action: 'touch'
          })

          const {
            is_authorized = false,
            customer_id = null,
            token = null
          } = res

          await this.updateState({
            isAuthorized: !!is_authorized,
            touch: {
              customer_id: customer_id
            }
          })

          return {
            is_authorized: !!is_authorized,
            customer_id,
            token
          }

        } catch (e) {
          $app.handleError(e)
        }

      },
      sync: async () => {
        try {
          await $app.$api({
            action: 'sync'
          })
        }  catch (e) {
          $app.handleError(e)
        }
      },
      authenticate: async (mail, password) => {

        await authenticate(mail, password).then(async () => {

          const {token} = await this.$auth.touch()

          setApiAuthToken(token)

        })

      },
      logout: () => {
        $app.$api({action: 'logout'}).then(res => {
          if(res && res.hasOwnProperty('was_successfull') === true) {
            removeApiAuthToken()
            void this.$auth.touch()

            this.props.navigate('/')
          }
        })
      },
      customerId: this.state.touch.customer_id
    }
  }

  async componentDidMount() {

    let [{isAuthorized}] = await Promise.all([
      await whereIsTheStateIn(),
      await sleep(1000)
    ])

    await this.updateState({
      isAuthorized,
      initialLoading: false
    })

  }

  render() {
    return (
      <>
        <WelcomeCurtain active={this.state.initialLoading}/>
        <AppHeader onScreen={!this.state.initialLoading && this.state.isAuthorized}/>
        <AppMenu activeItem={1} onScreen={!this.state.initialLoading} $auth={this.$auth}/>

        <main>


          <Routes>
            {this.state.isAuthorized ? (

              <>
                <Route path="/" element={<HomePage/>}></Route>
                <Route path="/rewards" element={<RewardsPage $auth={this.$auth}/>}/>
                <Route path="/account-update" element={<AccountUpdatePage/>}/>
                <Route path="/change-password" element={<AccountChangePasswordPage/>}/>
              </>

            ) : (

              <>
                <Route path="/" element={<LoginPage $auth={this.$auth}/>}/>
                <Route path="/registration" element={<RegistrationPage $auth={this.$auth} navigate={this.props.navigate}/>}/>
                <Route path="/password-recovery" element={<PasswordRecoveryPage $auth={this.$auth}/>}/>
                <Route path="/terms" element={<VOPPage/>}/>
                <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
              </>

            )
            }

            <Route path="/other" element={<OtherPage $auth={this.$auth}/>}/>
            <Route path="/reservation" element={<ReservationPage/>}/>

          </Routes>


          <Routes>
            <Route path="/menu" element={<FoodMenuPage/>}></Route>
          </Routes>

          <div className="menu-spacer"></div>
        </main>

      </>
    )
  }
}

export default function RootHOC() {
  const navigate = useNavigate()

  return (<Root navigate={navigate}/>)

}
